//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapActions, mapState} from "vuex";
import HomePageProductSlider from "@/frontend/components/page-sections/home-page-product-slider.vue";
export default {
  name: 'memorialsForPets',
  components: {HomePageProductSlider},
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      primaryProduct: {
        title: [],
        items: []
      },
      secondaryProduct: {
        title: "",
        items: []
      },
      currentIndex: 0,
    }
  },
  computed:{
    ...mapState('backoffice/product-catalog/productCatalog', ['productCategories']),
    valueStatementCurrentImageURL(){
      return this.section.value_statement_text[this.currentIndex].image.fieldValue.shortUrl;
    },
    producetDetailLink(){
      if(this.section.product_detail_link && this.section.product_detail_link.fieldValue){
        return this.section.product_detail_link.fieldValue.value
      }else{
        return "product"
      }
    }
  },
  async mounted(){
    await this.fetchProductCategories()
    await this.getProductForSlider();
  },
  methods: {
    ...mapActions('backoffice/product-catalog/productCatalog', ['fetchProductCategories']),
    async getProductForSlider(){
      if(this.section.primary_catalog_items && this.section.primary_catalog_items.fieldValue){
        const catalogIDs = this.getCategoryIDsFromCodes(this.section.primary_catalog_items.fieldValue.value)

        this.primaryProduct.items = await this.getSliderProducts(catalogIDs.map(a => a.id))
        this.primaryProduct.title = catalogIDs.map(a => a.name);

      }
      if(this.section.secondary_catalog_items && this.section.secondary_catalog_items.fieldValue){
        const catalogIDs = this.getCategoryIDsFromCodes(this.section.secondary_catalog_items.fieldValue.value)
        this.secondaryProduct.items = await this.getSliderProducts(catalogIDs.map(a => a.id))
        this.secondaryProduct.title = catalogIDs.map(a => a.name);
      }
    },
    getCategoryIDsFromCodes(categoryCodes){
      let codeArray = categoryCodes.split(',').map(function(item) {
        return item.trim();
      });
      return this.productCategories
        .filter(item => codeArray.includes(item.code))
        .map((item) => {
          return {
            id: item.id,
            name: item.name
          }
        });
    },
    async getSliderProducts(categoryIDS){
      const response = await this.$axios.$post('ProductCategories/productsFromMultipleCategory', {CategoryIDs : categoryIDS.toString()})
      return response
    }
  }
}
